module.exports = __webpack_public_path__ + "assets/img/5.943ab427.png";